<template>
<div>
  <el-tag
    v-for="tag in dynamicTags"
    :key="tag.title"
    :closable = "isClosable"
    :disable-transitions="false"
    :size="tagSize"
    @close="handleClose(tag)">
    {{tag.title}}
  </el-tag>
  <template v-if="isCreat">
    <el-input
      class="input-new-tag"
      v-if="inputVisible"
      v-model="inputValue"
      ref="saveTagInput"
      :size="btnSize"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm"
    >
    </el-input> 
    <el-button v-else class="button-new-tag" :size="btnSize" @click="showInput">+ 新建标签</el-button>

  </template>
 
</div>
</template>
<script>
import { Tag, Input, Button } from 'element-ui'
export default {
  name:'tagBox',
  props:{
    isCreat:{
      type:Boolean,
      default: false
    },
    tagSize:{
      type:String,
    },
    btnSize:{
      type:String,
      default: 'small'
    },
    tagList:{
      type:Array,
      default:()=>{
        return [];
      }
    },
    isClosable:{
      type:Boolean,
      default: false
    }
  },
  data(){
    return {
      inputVisible: false,
      inputValue: ''
    }
  },
  methods:{
    handleClose(tag) {
      this.$emit('change',tag);
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    }
  },
  mounted(){

  },
  computed:{
    dynamicTags:{
      get(){
        return this.tagList;
      },
      set(v){
        // this.$emit('updataTag',v);
      }
    }
  },
  components:{
    elTag: Tag,
    elInput: Input,
    elButton: Button
  }
}
</script>
<style scoped>

</style>
<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/tagBox.vue